import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function Ina({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>INA</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {sensor_id || d.sensor_id}<br />
          {formatTimestamp(d.timestamp)}{d.frequency && <> - {formatValue(d.frequency, 1)} Hz</>}
          <p style={{ marginLeft: '1em' }}>
            Voltage: {formatValue(d.bus_voltage)} V<br />
            Current: {formatValue(d.bus_current, 3)} A<br />
            Power: {formatValue(d.bus_voltage * d.bus_current)} W<br />
            Energy: {formatValue(d.energy)} Wh<br />
            Charge: {formatValue(d.charge/3600)} Ah<br />
            Temperature: {formatValue(d.temperature, 0)} °C<br />
          </p>
        </div>
      ))}
    </Item>
  );
}
